module.exports = __webpack_public_path__ + "static/media/st0t0s0.3ce30e88.wav";